import { gql } from 'graphql-request';

export const USER_FIELDS = gql`
  fragment UserFields on UserDto {
    userId
    firstName
    lastName
    email
    avatar
    role
    organizationId
    defaultOrganizationId
    lastLogin
    loginMethod
    status
    organizationRoleStatus
    locale
    createdAt
    dailyReportEmailEnabled
  }
`;

export const getSelf = gql`
  query getSelf {
    getSelf {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

export const getSelfWithOrganization = gql`
  query getSelfWithOrganization {
    getSelfWithOrganization {
      user {
        ...UserFields
      }
      organization {
        name
        organizationId
        status
      }
    }
  }
  ${USER_FIELDS}
`;

export const getAllowedRoles = gql`
  query getAllowedRoles {
    getAllowedRoles
  }
`;

export const getUsers = gql`
  query getUsers {
    getUsers {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

export const getUserByEmail = gql`
  query getUserByEmail($email: String!, $emailOrganizationId: String!) {
    getUserByEmail(email: $email, emailOrganizationId: $emailOrganizationId) {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

export const getPaginatedUsers = gql`
  query getPaginatedUsers($users: GetPaginatedUsersInput!) {
    getPaginatedUsers(users: $users) {
      users {
        ...UserFields
        organization {
          organizationId
          name
        }
        organizationRoles {
          organizationId
          role
          status
          organization {
            organizationId
            name
          }
        }
      }
      count
    }
  }
  ${USER_FIELDS}
`;

export const createUser = gql`
  mutation createUser($user: UserCreateInput!) {
    createUser(user: $user) {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

export const updateOwnUser = gql`
  mutation updateOwnUser($user: UserUpdateInput!) {
    updateOwnUser(user: $user) {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

export const updateOtherUser = gql`
  mutation updateOtherUser($user: UserUpdateInput!) {
    updateOtherUser(user: $user) {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

export const disableUser = gql`
  mutation disableUser($id: String!) {
    disableUser(id: $id) {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

export const enableUser = gql`
  mutation enableUser($id: String!) {
    enableUser(id: $id) {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

export const setDefaultOrganization = gql`
  mutation setDefaultOrganization($organizationId: String!) {
    setDefaultOrganization(organizationId: $organizationId) {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

export const getUserOrganizations = gql`
  query getUserOrganizations {
    getUserOrganizations {
      organizationId
      role
      userStatus
      subscriptionStatus
      trialEndsAt
      organization {
        organizationId
        name
        status
      }
    }
  }
`;

export const updateUserRole = gql`
  mutation updateUserRole($userId: String!, $organizationId: String!, $role: String!) {
    updateUserRole(userId: $userId, organizationId: $organizationId, role: $role) {
      organizationId
      role
      organization {
        organizationId
        name
        status
      }
    }
  }
`;

export const updateUserOrganizationRole = gql`
  mutation updateUserOrganizationRole($input: UpdateUserOrganizationRoleInput!) {
    updateUserOrganizationRole(input: $input) {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

export const updateUserOrganizationStatus = gql`
  mutation updateUserOrganizationStatus($input: UpdateUserOrganizationStatusInput!) {
    updateUserOrganizationStatus(input: $input) {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

const UserGraphQL = {
  queries: {
    getSelf,
    getSelfWithOrganization,
    getUsers,
    getUserByEmail,
    getPaginatedUsers,
    getAllowedRoles,
    getUserOrganizations,
  },
  mutations: {
    createUser,
    updateOwnUser,
    updateOtherUser,
    disableUser,
    enableUser,
    setDefaultOrganization,
    updateUserRole,
    updateUserOrganizationRole,
    updateUserOrganizationStatus,
  },
};

export default UserGraphQL;
